import {
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  Text,
} from '@chakra-ui/react'
import React, { useRef, useState } from 'react'
import { useCallback } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  getDashboardFunction,
  updateUserRole,
  updateUserWorkType,
} from '../../Api/dashboardFunction'
import { dashboard_functions } from '../../Utils/data'
import Dropdown from './Dropdown'
import './dropdown.css'
import Dropdown2 from './Dropdown2'

const FunctionDropdown = () => {
  const chooseFunctionButtonRef = useRef(null)

  const [dashboardFunction, setDashboardFunction] = useState(null)
  const [selectedWorkTypeValue, setSelectedWorkTypeValue] = useState(null)
  const [selectedRoleValue, setSelectedRoleValue] = useState(null)
  const [role, setRole] = useState([])

  const navigate = useNavigate()

  const fetchDashboardFunctions = useCallback(async () => {
    const temp = []
    dashboard_functions.forEach((item, index) => {
      temp.push({
        value: index + 10,
        label: item,
      })
    })
    setRole([...temp])
  }, [])

  useEffect(() => {
    fetchDashboardFunctions()
  }, [fetchDashboardFunctions])

  const dashboardLabel = role?.find(
    (option) => option.value === dashboardFunction
  )?.label

  const handleSelectWorkType = (optionValue) => {
    const selectedOption = role.find((option) => option.value === optionValue)
    setSelectedWorkTypeValue(selectedOption)
  }

  const handleSelectRole = (optionValue) => {
    const selectedOption = role.find((option) => option.value === optionValue)
    setSelectedRoleValue(selectedOption)
  }

  const handleClick = async (role, workType) => {
    // console.log(typeof role)
    const roleToLowerCase = role.toLowerCase()
    const workTypeToLowerCase = workType.toLowerCase()
    const apiResponse = await updateUserRole(roleToLowerCase)
    const workTypeApiResponse = await updateUserWorkType(workTypeToLowerCase)
    if (apiResponse && workTypeApiResponse) {
      navigate('/transcripts-summaries')
    }
  }

  return (
    <Box>
      <Box mb='28px'>
        <Text color='black' mb='5px'>
          What kind of work do you do?
        </Text>
        <Menu>
          <MenuButton
            as={Button}
            bgColor='transparent'
            color='black'
            border='1px'
            borderColor='blackAlpha.500'
            rightIcon={
              <Image src='/assets/icons/chevronDown.svg' color='white' />
            }
          >
            <Text color='blackAlpha.500'>
              {selectedWorkTypeValue
                ? selectedWorkTypeValue.label
                : 'Select a work type'}
            </Text>
          </MenuButton>
          <Dropdown2 data={role} onSelect={handleSelectWorkType} />
        </Menu>
      </Box>
      {/* <Box mb='52px'>
        <Text color='black' mb='5px'>
        Which platform do you use most?
        </Text>
        <Menu matchWidth>
          <MenuButton
            as={Button}
            bgColor='transparent'
            color='black'
            border='1px'
            borderColor='blackAlpha.500'
            rightIcon={
              <Image src='/assets/icons/chevronDown.svg' color='white' />
            }
          >
            <Text color='blackAlpha.500'>
              {selectedRoleValue ? selectedRoleValue.label : 'Pick a platform'}
            </Text>
          </MenuButton>
          <Dropdown2 data={role} onSelect={handleSelectRole} />
        </Menu>
      </Box> */}
      { selectedWorkTypeValue && (
        <Button
          bgColor='black'
          _hover={{ bg: 'black' }}
          color='white'
          onClick={() =>
            handleClick(selectedWorkTypeValue.label, selectedWorkTypeValue.label)
          }
        >
          <Flex align='center'>
            <Box mr={2}>
              <Text fontSize='md'>Next</Text>
            </Box>
            <Image
              src='/assets/icons/chevronRight.svg'
              boxSize={4}
              style={{ filter: 'invert(100%)' }}
            />
          </Flex>
        </Button>
      )}
    </Box>
  )
}

export default FunctionDropdown
